import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'dropdown',
    template: `
        <div [formGroup]="form">
        <select class="form-control" [id]="field.name" [formControl]="form">
          <option *ngFor="let opt of field.options" [value]="opt.key">{{opt.label}}</option>
        </select>
      </div> 
    `
})
export class DropDownComponent {
    @Input() field:any = {};
    @Input() form:FormGroup;

    // optionsModel: number[];
    // mySettings = {
    //   enableSearch: false,
    //   checkedStyle: 'checkboxes',
    //   buttonClasses: 'btn btn-default btn-block',
    //   maxHeight: '200px',
    //   displayAllSelectedText: false,
    //   dynamicTitleMaxItems: 100,
      
    // };
    // selected: any;
    // List: any[]

    constructor() {
      //console.log(this.field);
      
    }
}


// WEBPACK FOOTER //
// /home/bharath/agira-projects/asmart/agira-intranet-ui/src/app/offboarding/dynamic-form-builder/atoms/dropdown.ts